import { createSelector } from "reselect";

export const getMatchPreferences = ({ settings: { matchPreferences } }) => matchPreferences;

export const makeGetMatchPreferences = () => createSelector([getMatchPreferences], preferences => preferences);
